import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles
} from '@material-ui/core';

import styles from '../styles';
import flowRight from 'lodash.flowright';
import capitaliseFirstLetter from '../../../utils/capitaliseFirstLetter';
import { translate } from '../../../i18n/I18nProvider';
import Optional from '../../../utils/optional';
import { formatDateForSchedule } from '../../../utils/formatDate';
import ProductCell from './ProductCell';

const ConnectionDetailView = ({ connection, classes, lang }) => {
  const { subproducts = [] } = connection;
  if (subproducts.length === 0) {
    return <div className={classes.noData}>{translate('NO_DATA')}</div>;
  }

  return (
    <Table className={classes.tableRoot}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.headerCell}>
            {translate('TABLE.NAME')}
          </TableCell>
          <TableCell className={classes.headerCell}>
            {capitaliseFirstLetter(translate('SUBSCRIPTIONS.GROUP_BY_SKU'))}
          </TableCell>
          <TableCell className={classes.headerCell}>
            {translate('STATUS')}
          </TableCell>
          <TableCell className={classes.headerCell}>
            {translate('ACTIVATION_DATE')}
          </TableCell>
          <TableCell className={classes.headerCell}>
            {translate('EXPIRE_DATE')}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {subproducts.map((data, i) => (
          <TableRow key={i}>
            <TableCell className={classes.iconCell}>{data.name}</TableCell>
            <TableCell className={classes.iconCell}>
              {<ProductCell rowData={data} lang={lang} />}
            </TableCell>
            <TableCell className={classes.iconCell}>{data.status}</TableCell>
            <TableCell className={classes.iconCell}>
              {data.activationDate}
            </TableCell>
            <TableCell className={classes.iconCell}>
              {Optional(data.expiryDate)
                .map(date => formatDateForSchedule(date))
                .or('-')}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default flowRight(withStyles(styles))(ConnectionDetailView);
